import {useEffect, useState, useMemo} from 'react';
import Table from '../table';
import ActionBar from '../actionBar';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import {useAtomValue} from 'jotai';
import {pageSizeRecoil, showDeleted} from '../recoil';
import {dateFormatter} from '../dateFormatter';
import CreateWhitelistModal from './createWhitelist';
import EditWhitelist from './editWhitelist';
import PortalModal from '../portalModal';
import {Link} from 'react-router-dom';
import {useCustomerContext} from '../../lib/context/customerContext';

export const Whitelist = props => {
  const [pageNum, setPageNum] = useState(1);
  const [totalRecordsState, setTotalRecordsState] = useState(0);
  const showingDeleted = useAtomValue(showDeleted);
  const pageSize = useAtomValue(pageSizeRecoil);
  const {hasPermission} = useCustomerContext();

  const whitelistsFilters = useMemo(() => ({
    combineAnd: [
      { field: "options.show_deleted", value: `${showingDeleted}` },
      { field: "with.devices", value: "1" },
      { field: "options.page.num", value: `${pageNum}` },
      { field: "options.page.len", value: `${pageSize}` }
    ]
  }), [showingDeleted, pageNum, pageSize]);

  const {data, loading} = useQuery(WHITELISTS, {
    variables: { filters: whitelistsFilters }
  });

  const whitelists = data?.Whitelists?.result || [];

  const totalQueried = data?.Whitelists?.metadata?.page?.records ?? totalRecordsState;

  useEffect(()=> {
    setTotalRecordsState(totalQueried);
  }, [totalQueried]);

  const assignmentsFormatter = (cell, row) => {
    if(cell?.length) {
      return (  
        <Link className="hdm-assignments-link" to={'/ssid-whitelist/assignments'} state={{whitelist_ssid_list_id: row.id, title: row.name}} onClick={e => e.stopPropagation()}>
          {cell?.length}
        </Link>
      )
    } else {
      return '0'
    }
  }

  const columns = [
    { dataField: 'id', hidden: true },
    { dataField: 'name', text: 'List Name' },
    { dataField: 'devices', text: 'Assignments', formatter: assignmentsFormatter },
    { dataField: 'modified_at', text: 'Last Updated (UTC)', sort: true, formatter: dateFormatter, style: { width: '220px' } }
  ];
  
  return (
    <>
      <PortalModal>
        <EditWhitelist title="Edit List" type="wifi" />  
      </PortalModal>      
      <ActionBar
        showHidden={false}
        showSearchInput={false}
        title={"Wi-Fi SSID Lists"}
        pageDescription="These features are only available for SafeCase CRBN [i15] and CRBN X [S23]."
      >
        <CreateWhitelistModal disabled={!hasPermission('SSID_LIST_CREATE')} />
      </ActionBar>
      
      <Table
        testId="ssid-whitelist-table"
        columns={columns}
        data={whitelists}
        loading={loading}
        pageSize={pageSize}
        pageNum={pageNum}
        setPageNum={setPageNum}
        totalRecords={totalRecordsState}
      />
    </>
  );
};

const WHITELISTS = gql`
  query getWhitelists($filters: GenericFilters!) {
    Whitelists(filters: $filters) {
      result {
        id
        name
        created_at
        modified_at
        devices { id }
      }
      metadata { page { num len total inPage records } }
    }
  }
`;

export default Whitelist;
